import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app/App.tsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n/index.ts';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <StrictMode>
        <App />
    </StrictMode>
);